import { render, staticRenderFns } from "./motor-registration-card.vue?vue&type=template&id=14589287&"
import script from "./motor-registration-card.vue?vue&type=script&lang=js&"
export * from "./motor-registration-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports